import {Guide, guidesCountQueryOptions, PaginatedQuery} from '@blesk-frontend/api';
import {Updater, useMutation, useQueryClient} from '@tanstack/react-query';
import {fetchGuideDelete} from './fetchGuideDelete';

type GuideUpdaterData = Guide | PaginatedQuery<Guide> | undefined;

/**
 * This mutation hook is used to update the Guide.
 */
export const useGuideDeleteMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fetchGuideDelete,
    onSuccess(_data, variables) {
      queryClient.refetchQueries({queryKey: guidesCountQueryOptions().queryKey});

      const updater: Updater<GuideUpdaterData, GuideUpdaterData> = (old) => {
        if (!old) {
          return old;
        }
        if ('pagination' in old) {
          return {
            ...old,
            data: old.data.filter((guide) => guide.id !== variables.id),
          };
        }
      };
      queryClient.setQueriesData<GuideUpdaterData>({queryKey: ['guides']}, updater);
    },
  });
};
